import AccountingProvidersPage from './AccountingProvidersPage';

export default AccountingProvidersPage;
